import { render, staticRenderFns } from "./Btest.vue?vue&type=template&id=dc769ece&scoped=true"
import script from "./Btest.vue?vue&type=script&lang=js"
export * from "./Btest.vue?vue&type=script&lang=js"
import style0 from "./Btest.vue?vue&type=style&index=0&id=dc769ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc769ece",
  null
  
)

export default component.exports